var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0398 22.39L15.0518 22.397C17.2398 23.79 20.1018 23.4761 21.9358 21.642L22.7098 20.868C23.4296 20.1473 23.4296 18.9797 22.7098 18.259L19.4488 15C18.7281 14.2802 17.5605 14.2802 16.8398 15V15C16.4941 15.3461 16.025 15.5406 15.5358 15.5406C15.0466 15.5406 14.5775 15.3461 14.2318 15L9.01381 9.78099C8.294 9.06027 8.294 7.89271 9.01381 7.17199V7.17199C9.35993 6.8263 9.55442 6.35718 9.55442 5.86799C9.55442 5.37881 9.35993 4.90969 9.01381 4.56399L5.75381 1.29999C5.03309 0.580178 3.86553 0.580178 3.14481 1.29999L2.37081 2.07399C0.537098 3.90814 0.222852 6.76961 1.61481 8.95799L1.62281 8.96999C5.19623 14.2598 9.75079 18.8154 15.0398 22.39V22.39Z",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.17c274d523801a15d1b9024b96bff1ae.svg";
export { ForwardRef as ReactComponent };